import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadCurrentProductThunk from "Root/profile/redux/thunkCreators/products/currentProduct";
import Protein1 from "./results/protein-1-min.jpg";
import Protein2 from "./results/protein-2-min.jpg";
import Protein3 from "./results/protein-3-min.jpg";
import Preworkout1 from "./results/preworkout-1-min.jpg";
import Preworkout2 from "./results/preworkout-2-min.jpg";
import Preworkout3 from "./results/preworkout-3-min.jpg";
import Hydration1 from "./results/hydration-1-min.jpg";
import Hydration2 from "./results/hydration-2-min.jpg";
import Hydration3 from "./results/hydration-3-min.jpg";
import Collagen1 from "./results/collagen-1-min.jpg";
import Collagen2 from "./results/collagen-2-min.jpg";
import Collagen3 from "./results/collagen-3-min.jpg";
import Creatine1 from "./results/creatine-1-min.jpg";
import Creatine2 from "./results/creatine-2-min.jpg";
import Creatine3 from "./results/creatine-3-min.jpg";
import Fiber1 from "./results/fiber-1-min.jpg";
import Fiber2 from "./results/fiber-2-min.jpg";
import Fiber3 from "./results/fiber-3-min.jpg";
import Greens1 from "./results/greens-1.jpg";
import Greens2 from "./results/greens-2.jpg";
import Greens3 from "./results/greens-3.jpg";
const useCheckoutResultsProduct = (cartItem) => {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const swiperRef = useRef(null);
    const swiperThumbsRef = useRef(null);
    const [openDrawer, setOpenDrawer] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const dispatch = useDispatch();
    const [expanded, setExpanded] = useState({
        nutrition: false,
        ingredients: false,
        benefits: false,
        how_to_use: false,
        amino_acid: false,
    });
    const images = {
        protein: [Protein1, Protein2, Protein3],
        preworkout: [Preworkout1, Preworkout2, Preworkout3],
        hydration: [Hydration1, Hydration2, Hydration3],
        collagen: [Collagen1, Collagen2, Collagen3],
        creatine: [Creatine1, Creatine2, Creatine3],
        fiber: [Fiber1, Fiber2, Fiber3],
        greens: [Greens1, Greens2, Greens3]
    };
    const toggleDrawer = (value, scrollToNutritionFacts, callack) => () => {
        if (value && cartItem) {
            dispatch(LoadCurrentProductThunk(cartItem.item_type));
            if (scrollToNutritionFacts) {
                setTimeout(() => {
                    document
                        .getElementById("accordion-checkout0" + cartItem.item_type)
                        ?.scrollIntoView({ behavior: "smooth", block: "center" });
                    setExpanded({
                        ...expanded,
                        nutrition: true,
                    });
                }, 200);
            }
        }
        setExpanded({ ...expanded, nutrition: false });
        setOpenDrawer(value);
    };
    const onSwiperThumbs = (swiper) => {
        swiperThumbsRef.current = swiper;
    };
    const onSwiper = (swiper) => {
        swiperRef.current = swiper;
    };
    const changeSlide = (isNext) => {
        if (swiperRef.current) {
            if (isNext) {
                swiperRef.current.slideNext();
            }
            else {
                swiperRef.current.slidePrev();
            }
        }
    };
    const activeSlide = swiperRef.current?.activeIndex || 0;
    const userName = useSelector((state) => state.user.name);
    const getMacrosCopy = (macros) => {
        const macrosCopy = macros.split(" ");
        if (macrosCopy.length > 2) {
            return [macrosCopy[0], macrosCopy[1] + " " + macrosCopy[2]];
        }
        return macrosCopy;
    };
    return {
        userName,
        thumbsSwiper,
        setThumbsSwiper,
        onSwiperThumbs,
        swiperRef,
        changeSlide,
        swiperThumbsRef,
        onSwiper,
        activeSlide,
        openDrawer,
        toggleDrawer,
        activeIndex,
        onChangeSlide: (swiper) => {
            setActiveIndex(swiper.activeIndex);
        },
        expanded,
        setExpanded,
        images: images[cartItem?.item_type || "protein"],
        getMacrosCopy,
    };
};
export default useCheckoutResultsProduct;
